import React from 'react';

import { LandingData } from '../features/getLanding';

export const LandingDataContext = React.createContext<LandingData>({} as LandingData);

export const LandingDataProvider = LandingDataContext.Provider;
export const LandingDataConsumer = LandingDataContext.Consumer;
